const en = {
  welcome: {
    tagline1: 'Make your picks.',
    tagline2: 'Climb the leaderboard.',
    tagline3: 'Win prizes.',
    howToPlay: 'How to Play',
    letsPlay: "Let's Play",
  },
  howToPlay: {
    back: 'Back',
    title: 'How to Play',
    step1Title: "Pick'Em",
    step1Description: 'Lock in your predictions before the contest starts',
    step2Title: 'Score Big',
    step2Description: 'Every correct pick earns you points',
    step3Title: 'Beat the Competition',
    step3Description: 'Outscore friends and fans on the leaderboard',
    step4Title: 'Take the Glory',
    step4Description: 'Win prizes and claim bragging rights',
    cta: "Got it, Let's Play",
  },
  game: {
    status: {
      loading: 'Loading...',
      live: 'LIVE',
      complete: 'Complete',
      correct: 'correct',
    },
    actions: {
      edit: 'Edit',
      editPicks: 'Edit Picks',
      viewPicks: 'View Picks',
      playNow: 'Play Now',
      leaderboard: 'Leaderboard',
      viewLeaderboard: 'Leaderboard',
      viewResults: 'View Results',
    },
    results: {
      rank: 'Rank',
      totalPts: 'Total Pts',
    },
    labels: {
      start: 'Start:',
      picks: 'Picks:',
      firstPrize: '1st Prize:',
      vs: 'vs',
      yes: 'Yes',
      no: 'No',
    },
    time: {
      day: 'Day',
      days: 'Days',
      hour: 'Hour',
      hours: 'Hours',
      soon: 'Soon',
      startingSoon: 'Starting soon...',
    },
    contestClosed: 'This game has started and this contest is closed.',
    ordinals: {
      st: 'st',
      nd: 'nd',
      rd: 'rd',
      th: 'th',
    },
  },
  navigation: {
    filter: 'Filter',
    edit: 'Edit',
    chat: 'Chat',
    code: 'Code',
  },
  actions: {
    clear: 'Clear',
    clearSelection: 'Clear Selection',
    quickPick: 'Quick Pick',
    favouritePick: 'Popular Pick',
    contestDetails: 'Contest Details',
    moreOptions: 'More options',
    submitPicks: 'Submit Picks',
    submitting: 'Submitting...',
  },
  tabs: {
    lobby: 'Lobby',
    myPicks: 'My Picks',
    play: 'Play',
    recent: 'Recent',
    leaderboard: 'Leaderboard',
  },
  leaderboard: {
    today: 'Today',
    week: 'Week',
    season: 'Season',
    daily: 'Daily',
    monthly: 'Monthly',
    rank: 'Rank',
    user: 'User',
    points: 'Points',
    pickem: 'Pickem',
    scrollForMore: 'Scroll for more',
    failedToLoad: 'Failed to load leaderboard. Please try again.',
    noData: 'No leaderboard data available for this period.',
  },
  pages: {
    gamesCount: 'Select a contest',
    recentResults: 'Recent Results ({{count}})',
    noGamesAvailable: "Currently there are no PICK'EM games available to play",
    noCompletedGames: "There are no completed PICK'EM games yet.",
  },
  common: {
    picks: 'pick{{plural}}',
  },
  auth: {
    loginUnavailableTitle: "We couldn't reach the login page",
    loginUnavailableSubtitle: 'Please check your connection and try again.',
    retry: 'Try again',
  },
  footer: {
    termsAndConditions: 'Terms & Conditions',
  },
  tiebreaker: {
    title: 'Tiebreaker',
  },
  modal: {
    picksSubmitted: {
      title: 'Picks Submitted',
      message: 'Your picks are saved.',
      editMessage: 'Edit anytime before the contest starts.',
      returnToLobby: 'Return to Lobby',
      viewMyPicks: 'View My Picks',
    },
  },
} as const;

export default en;
